import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter(customer_id, agro_exporter_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/agro_exporter/${agro_exporter_id}`
    );
  },
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(customer_id, container_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_reports/${customer_id}/container/${container_id}`
    );
  },
  fetchCustomerReport(customer_id, customer_report_id) {
    return RequesterV1.get(
      `customer/reporting/container/show_customer_report/${customer_id}/customer_report/${customer_report_id}`
    );
  },
  fetchReport(customer_id, customer_report_id, container_id) {
    return RequesterV1.get(
      `customer/reporting/container/show_customer_report/${customer_id}/report/${customer_report_id}/${container_id}`
    );
  }
};
